const translationsWorkerDashboard = {
  english: {
    // Header
    english:'English',
    welcome: "Welcome",
    approval: "Approval",
    status: "Status",
    expandAll: "Expand All",
    collapseAll: "Collapse All",

    // Summary Cards
    totalEarnings: "Total Earnings",
    completedTasks: "Completed Tasks",
    pendingTasks: "Pending Tasks",

    // Error and Loading
    errorFirebaseNotInitialized: "Firebase not initialized.",
    errorUserDocumentNotExist: "User document does not exist.",
    errorAccessRestricted: "Access restricted to workers.",
    errorPleaseLogIn: "Please log in as a worker.",
    errorAuthStateChange: "Authentication error",
    errorInitialization: "Initialization error",
    errorFetchingOrders: "Error fetching orders",
    errorFetchingRejectedOrders: "Error fetching rejected orders",

    // Pending Tasks Section
    noTasksAssigned: "No tasks assigned yet.",
    serviceFeeWarning: "Please pay your outstanding service fee of ₹{amount} to accept new orders.",
    earningsAfterFee: "Earnings: ₹{amount} (after 2% service fee)",
    timeout: "Timeout",
    maleWorkers: "Male Workers",
    femaleWorkers: "Female Workers",
    bundle: "Bundle",
    hours: "Hours",
    days: "Days",
    startDate: "Start Date",
    endDate: "End Date",
    startTime: "Start Time",
    address: "Address",
    pincode: "Pincode",
    pincodeMissing: "[Missing]",
    contact: "Contact",
    paymentMethod: "Payment Method",
    note: "Note",
    none: "None",
    accept: "Accept",
    reject: "Reject",
    cannotAcceptTask: "You cannot accept this task now.",
    markAsCompleted: "Mark as Completed",
    selectPaymentMethod: "Select Payment Method",
    paymentMethodCash: "Cash",
    paymentMethodOnline: "Online",

    // Rejected Tasks Section
    rejectedTasks: "Rejected Tasks",
    noTasksRejected: "No tasks rejected.",
    pendingReassignment: "Pending Reassignment",
    potentialEarnings: "Potential Earnings",
    taskRejectedPendingReassignment: "This task was rejected and is pending reassignment.",

    // Earnings Section
    earnings: "Earnings",
    serviceFeeWallet: "Service Fee Wallet",
    payServiceFee: "Pay Service Fee",
    noEarningsRecorded: "No earnings recorded yet.",
    orderId: "Order ID",
    service: "Service",
    serviceFee: "Service Fee (2%)",
    completed: "Completed",

    // Availability Section
    setAvailability: "Set Availability",
    date: "Date",
    type: "Type",
    workingDay: "Working Day",
    offDay: "Off Day",
    updateAvailability: "Update Availability",
    workingDays: "Working Days",
    noWorkingDays: "No working days set.",
    offDays: "Off Days",
    noOffDays: "No off days set.",

    // Skills Section
    manageSkills: "Manage Skills",
    selectSkills: "Select Skills",
    skillsInstruction: "Hold Ctrl (Cmd on Mac) to select multiple skills.",
    currentSkills: "Current Skills",
    noSkillsSelected: "No skills selected.",
    updateSkills: "Update Skills",

    // Profile Section
    editProfile: "Edit Profile",
    name: "Name",
    mobileNumber: "Mobile Number",
    mobilePlaceholder: "Enter 10-digit mobile number",
    gender: "Gender",
    selectGender: "Select Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    workerStatusLabel: "Worker Status",
    ready: "Ready",
    busy: "Busy",
    updateProfile: "Update Profile",

    // Alerts and Errors
    errorSelectPaymentMethod: "Please select a payment method.",
    errorOrderNotFound: "Order {orderId} not found.",
    errorInvalidOrderCost: "Invalid order cost.",
    errorInvalidWorkerCount: "Invalid worker count.",
    errorCompletingOrder: "Error completing order",
    successOrderCompleted: "Task marked as completed and payment recorded!",
    errorPaymentGatewayNotLoaded: "Payment gateway not loaded. Please try again.",
    errorServiceFeeLow: "Service fee wallet balance is less than ₹100. No payment required.",
    errorInitiatingPayment: "Error initiating payment",
    successServiceFeePaid: "Service fee paid successfully!",
    errorSavingPayment: "Error saving payment",
    paymentCancelled: "Payment cancelled by user.",
    paymentFailed: "Payment failed",
    errorSelectDate: "Please select a date.",
    errorUpdatingAvailability: "Error updating availability",
    successAvailabilityUpdated: "Availability updated successfully!",
    errorSelectSkill: "Please select at least one skill.",
    errorUpdatingSkills: "Error updating skills",
    successSkillsUpdated: "Skills updated successfully!",
    errorInvalidPincode: "Pincode must be a 6-digit number.",
    errorInvalidMobile: "Mobile number must be a 10-digit number.",
    errorInvalidWorkerStatus: "Invalid worker status selected.",
    errorUpdatingProfile: "Error updating profile",
    successProfileUpdated: "Profile updated successfully!",
    errorRejectingOrder: "Error rejecting order",
    successOrderRejected: "Order rejected successfully! It is now pending reassignment by the admin.",
    errorHandlingTimeout: "Error handling timeout",

    // Service Types
    'farm-workers': "Farm Workers",
    'ownertc': "Owner Tractor",
    'ploughing-laborer': "Ploughing Laborer",

    // Skills
    'farm-worker': "Farm Worker",
    'tractor-driver': "Tractor Driver",

    // WhatsApp Messages (for handleAcceptOrder, handleCompleteOrder, handleRejectOrder)
    orderAccepted: "Order accepted on KhetiSathi! 🚜\n\nI am {name} (Contact: {mobile}), your assigned worker for the {service} service. I will arrive soon at {address}. For any queries, please contact me. Regards, KhetiSathi",
    orderAcceptedFailedWhatsApp: "Failed to send WhatsApp notification to farmer, but proceeding with order acceptance.",
    successOrderAccepted: "Order accepted successfully!",
    orderCompleted: "Order Completed on KhetiSathi! 🚜\n\n• 👷 Worker: {name} ({mobile})\n• 🛠️ Service: {service}\n• 💰 Gross Earnings: ₹{grossEarnings}\n• 💵 Service Fee (2%): ₹{serviceFee}\n• 💳 Net Earnings: ₹{netEarnings}\n• 📅 Completed Date: {completedDate}\n• 📍 Address: {address}\n• 💳 Payment Method: {paymentMethod}\n\n🌟 Order ID: {orderId}",
  },
  hindi: {
    // Header
    welcome: "स्वागत है",
    approval: "अनुमोदन",
    status: "स्थिति",
    expandAll: "सभी विस्तार करें",
    collapseAll: "सभी संकुचित करें",

    // Summary Cards
    totalEarnings: "कुल आय",
    completedTasks: "पूरा किए गए कार्य",
    pendingTasks: "लंबित कार्य",

    // Error and Loading
    errorFirebaseNotInitialized: "Firebase प्रारंभ नहीं हुआ।",
    errorUserDocumentNotExist: "उपयोगकर्ता दस्तावेज़ मौजूद नहीं है।",
    errorAccessRestricted: "केवल श्रमिकों के लिए पहुँच प्रतिबंधित है।",
    errorPleaseLogIn: "कृपया श्रमिक के रूप में लॉग इन करें।",
    errorAuthStateChange: "प्रमाणीकरण त्रुटि",
    errorInitialization: "प्रारंभ त्रुटि",
    errorFetchingOrders: "ऑर्डर प्राप्त करने में त्रुटि",
    errorFetchingRejectedOrders: "अस्वीकृत ऑर्डर प्राप्त करने में त्रुटि",

    // Pending Tasks Section
    noTasksAssigned: "अभी तक कोई कार्य सौंपा नहीं गया।",
    serviceFeeWarning: "कृपया नए ऑर्डर स्वीकार करने के लिए ₹{amount} की बकाया सेवा शुल्क का भुगतान करें।",
    earningsAfterFee: "आय: ₹{amount} (2% सेवा शुल्क के बाद)",
    timeout: "समय समाप्त",
    maleWorkers: "पुरुष श्रमिक",
    femaleWorkers: "महिला श्रमिक",
    bundle: "बंडल",
    hours: "घंटे",
    days: "दिन",
    startDate: "प्रारंभ तिथि",
    endDate: "समाप्ति तिथि",
    startTime: "प्रारंभ समय",
    address: "पता",
    pincode: "पिनकोड",
    pincodeMissing: "[अनुपस्थित]",
    contact: "संपर्क",
    paymentMethod: "भुगतान विधि",
    note: "नोट",
    none: "कोई नहीं",
    accept: "स्वीकार करें",
    reject: "अस्वीकार करें",
    cannotAcceptTask: "आप अब इस कार्य को स्वीकार नहीं कर सकते।",
    markAsCompleted: "पूरा हुआ चिह्नित करें",
    selectPaymentMethod: "भुगतान विधि चुनें",
    paymentMethodCash: "नकद",
    paymentMethodOnline: "ऑनलाइन",

    // Rejected Tasks Section
    rejectedTasks: "अस्वीकृत कार्य",
    noTasksRejected: "कोई कार्य अस्वीकृत नहीं।",
    pendingReassignment: "पुन: असाइनमेंट लंबित",
    potentialEarnings: "संभावित आय",
    taskRejectedPendingReassignment: "यह कार्य अस्वीकृत किया गया था और पुन: असाइनमेंट लंबित है।",

    // Earnings Section
    earnings: "आय",
    serviceFeeWallet: "सेवा शुल्क वॉलेट",
    payServiceFee: "सेवा शुल्क का भुगतान करें",
    noEarningsRecorded: "अभी तक कोई आय दर्ज नहीं की गई।",
    orderId: "ऑर्डर आईडी",
    service: "सेवा",
    serviceFee: "सेवा शुल्क (2%)",
    completed: "पूरा हुआ",

    // Availability Section
    setAvailability: "उपलब्धता सेट करें",
    date: "तिथि",
    type: "प्रकार",
    workingDay: "कार्य दिवस",
    offDay: "अवकाश दिवस",
    updateAvailability: "उपलब्धता अपडेट करें",
    workingDays: "कार्य दिवस",
    noWorkingDays: "कोई कार्य दिवस सेट नहीं।",
    offDays: "अवकाश दिवस",
    noOffDays: "कोई अवकाश दिवस सेट नहीं।",

    // Skills Section
    manageSkills: "कौशल प्रबंधन",
    selectSkills: "कौशल चुनें",
    skillsInstruction: "एकाधिक कौशल चुनने के लिए Ctrl (Mac पर Cmd) दबाए रखें।",
    currentSkills: "वर्तमान कौशल",
    noSkillsSelected: "कोई कौशल चयनित नहीं।",
    updateSkills: "कौशल अपडेट करें",

    // Profile Section
    editProfile: "प्रोफाइल संपादित करें",
    name: "नाम",
    mobileNumber: "मोबाइल नंबर",
    mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
    gender: "लिंग",
    selectGender: "लिंग चुनें",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    workerStatusLabel: "श्रमिक स्थिति",
    ready: "तैयार",
    busy: "व्यस्त",
    updateProfile: "प्रोफाइल अपडेट करें",

    // Alerts and Errors
    errorSelectPaymentMethod: "कृपया भुगतान विधि चुनें।",
    errorOrderNotFound: "ऑर्डर {orderId} नहीं मिला।",
    errorInvalidOrderCost: "अवैध ऑर्डर लागत।",
    errorInvalidWorkerCount: "अवैध श्रमिक संख्या।",
    errorCompletingOrder: "ऑर्डर पूरा करने में त्रुटि",
    successOrderCompleted: "कार्य पूरा हुआ और भुगतान दर्ज किया गया!",
    errorPaymentGatewayNotLoaded: "भुगतान गेटवे लोड नहीं हुआ। कृपया पुन: प्रयास करें।",
    errorServiceFeeLow: "सेवा शुल्क वॉलेट शेष ₹100 से कम है। भुगतान की आवश्यकता नहीं है।",
    errorInitiatingPayment: "भुगतान शुरू करने में त्रुटि",
    successServiceFeePaid: "सेवा शुल्क सफलतापूर्वक भुगतान किया गया!",
    errorSavingPayment: "भुगतान सहेजने में त्रुटि",
    paymentCancelled: "उपयोगकर्ता द्वारा भुगतान रद्द किया गया।",
    paymentFailed: "भुगतान विफल",
    errorSelectDate: "कृपया तारीख चुनें।",
    errorUpdatingAvailability: "उपलब्धता अपडेट करने में त्रुटि",
    successAvailabilityUpdated: "उपलब्धता सफलतापूर्वक अपडेट की गई!",
    errorSelectSkill: "कृपया कम से कम एक कौशल चुनें।",
    errorUpdatingSkills: "कौशल अपडेट करने में त्रुटि",
    successSkillsUpdated: "कौशल सफलतापूर्वक अपडेट किए गए!",
    errorInvalidPincode: "पिनकोड 6 अंकों का होना चाहिए।",
    errorInvalidMobile: "मोबाइल नंबर 10 अंकों का होना चाहिए।",
    errorInvalidWorkerStatus: "अवैध श्रमिक स्थिति चयनित।",
    errorUpdatingProfile: "प्रोफाइल अपडेट करने में त्रुटि",
    successProfileUpdated: "प्रोफाइल सफलतापूर्वक अपडेट की गई!",
    errorRejectingOrder: "ऑर्डर अस्वीकार करने में त्रुटि",
    successOrderRejected: "ऑर्डर सफलतापूर्वक अस्वीकार किया गया! यह अब व्यवस्थापक द्वारा पुन: असाइनमेंट के लिए लंबित है।",
    errorHandlingTimeout: "समय समाप्ति संभालने में त्रुटि",

    // Service Types
    'farm-workers': "खेत श्रमिक",
    'ownertc': "मालिक ट्रैक्टर",
    'ploughing-laborer': "जुताई श्रमिक",

    // Skills
    'farm-worker': "खेत श्रमिक",
    'tractor-driver': "ट्रैक्टर चालक",


    // WhatsApp Messages
    orderAccepted: "खेतीसाथी पर ऑर्डर स्वीकार किया गया! 🚜\n\nमैं {name} (संपर्क: {mobile}) हूँ, आपके {service} सेवा के लिए नियुक्त श्रमिक। मैं जल्द ही {address} पर पहुँचूँगा। किसी भी प्रश्न के लिए, कृपया मुझसे संपर्क करें। सादर, खेतीसाथी",
    orderAcceptedFailedWhatsApp: "किसान को WhatsApp सूचना भेजने में विफल, लेकिन ऑर्डर स्वीकार प्रक्रिया जारी है।",
    successOrderAccepted: "ऑर्डर सफलतापूर्वक स्वीकार किया गया!",
    orderCompleted: "खेतीसाथी पर ऑर्डर पूरा हुआ! 🚜\n\n• 👷 श्रमिक: {name} ({mobile})\n• 🛠️ सेवा: {service}\n• 💰 कुल आय: ₹{grossEarnings}\n• 💵 सेवा शुल्क (2%): ₹{serviceFee}\n• 💳 निव्वळ आय: ₹{netEarnings}\n• 📅 पूर्ण तिथि: {completedDate}\n• 📍 पता: {address}\n• 💳 भुगतान विधि: {paymentMethod}\n\n🌟 ऑर्डर आईडी: {orderId}",
  },
  marathi: {
    // Header
    welcome: "स्वागत आहे",
    approval: "मान्यता",
    status: "स्थिती",
    expandAll: "सर्व विस्तारित करा",
    collapseAll: "सर्व संकुचित करा",

    // Summary Cards
    totalEarnings: "एकूण कमाई",
    completedTasks: "पूर्ण झालेले कार्य",
    pendingTasks: "प्रलंबित कार्य",

    // Error and Loading
    errorFirebaseNotInitialized: "Firebase प्रारंभ झाले नाही.",
    errorUserDocumentNotExist: "वापरकर्ता दस्तऐवज अस्तित्वात नाही.",
    errorAccessRestricted: "केवळ कामगारांसाठी प्रवेश प्रतिबंधित आहे.",
    errorPleaseLogIn: "कृपया कामगार म्हणून लॉग इन करा.",
    errorAuthStateChange: "प्रमाणीकरण त्रुटी",
    errorInitialization: "प्रारंभ त्रुटी",
    errorFetchingOrders: "ऑर्डर प्राप्त करण्यात त्रुटी",
    errorFetchingRejectedOrders: "अस्वीकृत ऑर्डर प्राप्त करण्यात त्रुटी",

    // Pending Tasks Section
    noTasksAssigned: "अजून कोणतेही कार्य नियुक्त केलेले नाही.",
    serviceFeeWarning: "कृपया नवीन ऑर्डर स्वीकारण्यासाठी ₹{amount} ची थकित सेवा शुल्क भरा.",
    earningsAfterFee: "कमाई: ₹{amount} (2% सेवा शुल्कानंतर)",
    timeout: "वेळ संपली",
    maleWorkers: "पुरुष कामगार",
    femaleWorkers: "महिला कामगार",
    bundle: "बंडल",
    hours: "तास",
    days: "दिवस",
    startDate: "प्रारंभ तारीख",
    endDate: "समाप्ती तारीख",
    startTime: "प्रारंभ वेळ",
    address: "पत्ता",
    pincode: "पिनकोड",
    pincodeMissing: "[गहाळ]",
    contact: "संपर्क",
    paymentMethod: "पेमेंट पद्धत",
    note: "टिप",
    none: "काही नाही",
    accept: "स्वीकारा",
    reject: "नाकारा",
    cannotAcceptTask: "आता तुम्ही हे कार्य स्वीकारू शकत नाही.",
    markAsCompleted: "पूर्ण झाले असे चिन्हित करा",
    selectPaymentMethod: "पेमेंट पद्धत निवडा",
    paymentMethodCash: "रोख",
    paymentMethodOnline: "ऑनलाइन",

    // Rejected Tasks Section
    rejectedTasks: "अस्वीकृत कार्य",
    noTasksRejected: "कोणतेही कार्य अस्वीकृत नाही.",
    pendingReassignment: "पुन:नियुक्ती प्रलंबित",
    potentialEarnings: "संभाव्य कमाई",
    taskRejectedPendingReassignment: "हे कार्य अस्वीकृत केले गेले आणि पुन:नियुक्ती प्रलंबित आहे.",

    // Earnings Section
    earnings: "कमाई",
    serviceFeeWallet: "सेवा शुल्क वॉलेट",
    payServiceFee: "सेवा शुल्क भरा",
    noEarningsRecorded: "अजून कोणतीही कमाई नोंदवली गेली नाही.",
    orderId: "ऑर्डर आयडी",
    service: "सेवा",
    serviceFee: "सेवा शुल्क (2%)",
    completed: "पूर्ण झाले",

    // Availability Section
    setAvailability: "उपलब्धता सेट करा",
    date: "तारीख",
    type: "प्रकार",
    workingDay: "कार्य दिवस",
    offDay: "सुट्टीचा दिवस",
    updateAvailability: "उपलब्धता अपडेट करा",
    workingDays: "कार्य दिवस",
    noWorkingDays: "कोणतेही कार्य दिवस सेट केले नाहीत.",
    offDays: "सुट्टीचे दिवस",
    noOffDays: "कोणतेही सुट्टीचे दिवस सेट केले नाहीत.",

    // Skills Section
    manageSkills: "कौशल व्यवस्थापन",
    selectSkills: "कौशल्य निवडा",
    skillsInstruction: "एकापेक्षा जास्त कौशल्य निवडण्यासाठी Ctrl (Mac वर Cmd) दाबा.",
    currentSkills: "वर्तमान कौशल्य",
    noSkillsSelected: "कोणतेही कौशल्य निवडले नाही.",
    updateSkills: "कौशल्य अपडेट करा",

    // Profile Section
    editProfile: "प्रोफाइल संपादन",
    name: "नाव",
    mobileNumber: "मोबाइल नंबर",
    mobilePlaceholder: "10 अंकांचा मोबाइल नंबर प्रविष्ट करा",
    gender: "लिंग",
    selectGender: "लिंग निवडा",
    male: "पुरुष",
    female: "महिला",
    other: "इतर",
    workerStatusLabel: "कामगार स्थिती",
    ready: "तयार",
    busy: "व्यस्त",
    updateProfile: "प्रोफाइल अपडेट करा",

    // Alerts and Errors
    errorSelectPaymentMethod: "कृपया पेमेंट पद्धत निवडा.",
    errorOrderNotFound: "ऑर्डर {orderId} सापडली नाही.",
    errorInvalidOrderCost: "अवैध ऑर्डर खर्च.",
    errorInvalidWorkerCount: "अवैध कामगार संख्या.",
    errorCompletingOrder: "ऑर्डर पूर्ण करण्यात त्रुटी",
    successOrderCompleted: "कार्य पूर्ण झाले आणि पेमेंट नोंदवले गेले!",
    errorPaymentGatewayNotLoaded: "पेमेंट गेटवे लोड झाले नाही. कृपया पुन्हा प्रयत्न करा.",
    errorServiceFeeLow: "सेवा शुल्क वॉलेट शिल्लक ₹100 पेक्षा कमी आहे. पेमेंट आवश्यक नाही.",
    errorInitiatingPayment: "पेमेंट सुरू करण्यात त्रुटी",
    successServiceFeePaid: "सेवा शुल्क यशस्वीपणे भरण्यात आले!",
    errorSavingPayment: "पेमेंट जतन करण्यात त्रुटी",
    paymentCancelled: "वापरकर्त्याने पेमेंट रद्द केले.",
    paymentFailed: "पेमेंट अयशस्वी",
    errorSelectDate: "कृपया तारीख निवडा.",
    errorUpdatingAvailability: "उपलब्धता अपडेट करण्यात त्रुटी",
    successAvailabilityUpdated: "उपलब्धता यशस्वीपणे अपडेट केली!",
    errorSelectSkill: "कृपया किमान एक कौशल्य निवडा.",
    errorUpdatingSkills: "कौशल्य अपडेट करण्यात त्रुटी",
    successSkillsUpdated: "कौशल्य यशस्वीपणे अपडेट केले!",
    errorInvalidPincode: "पिनकोड 6 अंकांचा असावा.",
    errorInvalidMobile: "मोबाइल नंबर 10 अंकांचा असावा.",
    errorInvalidWorkerStatus: "अवैध कामगार स्थिती निवडली गेली.",
    errorUpdatingProfile: "प्रोफाइल अपडेट करण्यात त्रुटी",
    successProfileUpdated: "प्रोफाइल यशस्वीपणे अपडेट केली!",
    errorRejectingOrder: "ऑर्डर नाकारण्यात त्रुटी",
    successOrderRejected: "ऑर्डर यशस्वीपणे नाकारली गेली! ती आता प्रशासकाद्वारे पुन:नियुक्तीसाठी प्रलंबित आहे.",
    errorHandlingTimeout: "वेळ संपल्याची त्रुटी हाताळण्यात",

    // Service Types
    'farm-workers': "शेत कामगार",
    'ownertc': "मालक ट्रॅक्टर",
    'ploughing-laborer': "नांगरणी कामगार",

    // Skills
    'farm-worker': "शेत कामगार",
    'tractor-driver': "ट्रॅक्टर चालक",

    // WhatsApp Messages
    orderAccepted: "खेतीसाथीवर ऑर्डर स्वीकारली गेली! 🚜\n\nमी {name} (संपर्क: {mobile}), तुमच्या {service} सेवेसाठी नियुक्त कामगार आहे. मी लवकरच {address} येथे पोहोचेन. काही प्रश्न असल्यास, कृपया माझ्याशी संपर्क साधा. सादर, खेतीसाथी",
    orderAcceptedFailedWhatsApp: "शेतकऱ्याला WhatsApp सूचना पाठवण्यात अयशस्वी, परंतु ऑर्डर स्वीकार प्रक्रिया सुरू आहे.",
    successOrderAccepted: "ऑर्डर यशस्वीपणे स्वीकारली गेली!",
    orderCompleted: "खेतीसाथीवर ऑर्डर पूर्ण झाली! 🚜\n\n• 👷 कामगार: {name} ({mobile})\n• 🛠️ सेवा: {service}\n• 💰 एकूण कमाई: ₹{grossEarnings}\n• 💵 सेवा शुल्क (2%): ₹{serviceFee}\n• 💳 निव्वळ कमाई: ₹{netEarnings}\n• 📅 पूर्ण झाल्याची तारीख: {completedDate}\n• 📍 पत्ता: {address}\n• 💳 पेमेंट पद्धत: {paymentMethod}\n\n🌟 ऑर्डर आयडी: {orderId}",
  },
};

export default translationsWorkerDashboard;